import { Component, OnInit, Renderer2,TemplateRef, ViewChild} from '@angular/core';
import { BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
import {AngularFireDatabase} from '@angular/fire/database';

@Component({
  selector: 'app-img',
  templateUrl: './img.component.html',
  styleUrls: ['./img.component.scss']
})
export class ImgComponent implements OnInit {
//liste des tâches avec leur consigne et leur code
str = `
"1 ; Dans votre emploi du temps, ouvrez le lien Zoom du premier cours du 03/22/2021. Ensuite copiez l'URL (de la page Zoom ouverte) dans le champ ci-dessous.  ; https://univ-grenoble-alpes-fr.zoom.us/j/93856883216?pwd=ZVlSSEFtelZzQ0xVbVNHNm1TUmVKZz09#success"
"2 ; Vous avez reçu un mail de Sophie Dupuy Chessa, parlant d'un QCM. Copiez la date du QCM (au format jj/mm/aaaa) dans le champ ci-dessous. ; 22/03/2021" 
"3 ; A quelle date avez vous emprunter le livre 'Design Pattern' ? Copiez la date d'emprunt (au format jj/mm/aaaa) dans le champ ci-dessous. ; 15/02/2021" 
"4 ; Retouvez le lien du cours de Lucas BISOGNIN qui a eu lieu au S7 (semestre précédent). Copiez ce lien dans le champ ci-dessous. ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244" 
"5 ; Quel le nom et prénom de l'enseignante d'Anglais au S8 ? Copiez son nom (au format Prénom NOM) dans le champ ci dessous. ; Sally BROWN" 
"6 ; Retrouvez l'adresse mail de George Brassens. Copiez la dans le champ ci-dessous. ; brassensgoerg@uga.fr" 
"7 ; Quel est le format de votre notification de bourse ? Copiez le format en majuscule dans le champ ci-dessous. ; PDF"  
"8 ; Quel est le solde IZLY ? Copier le (sans le symbole '€') dans le champ ci-dessous. ; 12"  
"9 ; Quel est le solde papercut ? Copier le (sans le symbole '€') dans le champ ci-dessous. ; 2" 
`;
strI =`
  "Bonjour, merci d’avoir accepté de participer à ce test. ; Le texte qui suit va vous paraître un peu formel mais il nous assure que tous les participants recevront la même information. ; Vous devez impérativement être étudiant en Licence ou Master au sein de l’UGA pour participer à ce test, si ce n’est pas le cas vous pouvez dès à présent quitter la page. "
  "L’objectif de notre étude est de tester le site web du dashboard étudiant qui a été conçu dans le cadre du cours d'interaction homme machine (IHM) de M1 WIC au sein de l’UGA. ; Au cours de ce test, vous allez devoir réaliser plusieurs tâches bien définies de manière successive. Ce n’est pas vous que nous testons, mais le logiciel. ; Ce test devrait prendre entre 5 et 10 minutes, mais vous pourrez l’arrêter quand vous le voudrez si vous ne vous sentez pas à l’aise. À la fin du test, vous serez redirigé vers un cours questionnaire auquel nous vous invitons à répondre de manière assidue. "
  "Les données recueillies lors de ce test seront anonymes et confidentielles. Vous pouvez à tout moment demander la suppression de ces données. ; Pour ce faire, nous vous demandons de choisir un code de trois lettres pour pouvoir identifier vos données. Vous devrez nous communiquer ce même code lors de votre demande de suppression. ; Adresse mail contact : cedric.pinard@etu.univ-grenoble-alpes.fr "
  "Il est impératif de réaliser ce test depuis un ordinateur. (non compatible avec smartphone et tablette) ; Cette expérience a pour but de vous faire naviguer dans le dashboard. ; Chaque tâche s’articulera autour de données, à récupérer dans le dashboard et à reporter dans le champ dédié. Les consignes de chaque tâche vous seront présentées de manière successive."
  "Dans l’interface du dashboard nous avons rajouté un bouton tâche que vous pouvez voir en bas à droite de votre écran. ; Ce bouton ouvrira une pop-up contenant : les consignes de la tâche (si besoin de les consulter à nouveau), un champ pour insérer les données demandées trouvées (au bon format) et un bouton pour passer à la tâche suivante. ; Important : si vous ne trouvez pas le code vous êtes libre de passer à la tâche suivante sans renseigner le champ dédié."
`;

//on transforme la liste en array 
tab: any = this.parse(this.str);
instruction: any = this.parseI(this.strI);

//on définit l'ordre des taches aléatoirement
preOrdre:number[] = [0,1,2,3,4,5,6,7,8];
ordre:number[] = this.randomiseArray(this.preOrdre);

@ViewChild('debut', { static: true }) debut!: TemplateRef<any>;
@ViewChild('template', { static: true }) template!: TemplateRef<any>;
@ViewChild('fin', { static: true }) fin!: TemplateRef<any>;

instruc:number=0;
increment:number=0;
tempsDebut:Date = new Date();
tempsFin:Date = new Date();
code:string="";
nbclick:number=0;
resultats: RESULTAT[] = [];
codeUser:string="";

clicklistener=this.renderer.listen('window','click',(evt) => {
  this.nbclick++;});


modalRef!:BsModalRef;

constructor(public db: AngularFireDatabase,private modalService:BsModalService, private renderer:Renderer2) {
 }
public openModal(){
  if(this.instruc<this.instruction.length){
    this.modalRef = this.modalService.show(this.debut);
  }else if(this.increment<this.tab.length){
    this.modalRef = this.modalService.show(this.template);
  }else{
    this.modalRef = this.modalService.show(this.fin);
  }
}



ngOnInit(): void {
  this.openModal()  ;
}

parse(str: string): TACHE[] {

  const L: TACHE [] = str.trim().split("\n").map(s => s.trim()).filter(s => s!=="")

               .map( s => s.split(";").map( s => s.slice(1, -1) ) )

               .map( ([t,c,o]) => ({

                id: t,

                consigne: c,
                   
                code: o,
               }));
  return L;

}

parseI(str: string): INSTRUCTION[] {

  const L: INSTRUCTION [] = str.trim().split("\n").map(s => s.trim()).filter(s => s!=="")

               .map( s => s.split(";").map( s => s.slice(1, -1) ) )

               .map( ([t,c,o]) => ({

                p1: t,

                p2: c,
                   
                p3: o,
               }));
               console.log(L);
  return L;

}

next(){
  if(this.instruc<this.instruction.length-1){
    if(this.instruc==2){
      this.codeUser=(<HTMLInputElement>document.getElementById("codeUser")).value;
    }
    this.instruc++;
    console.log(this.codeUser);
  }else if(this.instruc==this.instruction.length-1){
    this.modalRef.hide();
    this.instruc++;
    this.nbclick=0;
    this.tempsDebut= new Date();
    this.openModal();
  }else if(this.increment<this.tab.length-1){
    this.saveResult();
    this.increment++;
  }else if(this.increment==this.tab.length-1){
    this.saveResult();
    this.storeResult();
    this.modalRef.hide();
    this.increment++;
    this.openModal();
  }
}


storeResult(){
  this.db.list(this.codeUser).push({ content: this.resultats});
}

saveResult() {
  this.code=(<HTMLInputElement>document.getElementById("code")).value;
  this.tempsFin = new Date();
  let res:RESULTAT={
    tache:this.tab[this.ordre[this.increment]].id,
    temps: (this.tempsFin.getTime() - this.tempsDebut.getTime())/1000,
    nbclick: this.nbclick-2,
    succes: this.tab[this.ordre[this.increment]].code==this.code
  };
  this.resultats[this.increment]=res;
  this.tempsDebut = new Date();
  this.nbclick = 0;
  console.log(this.resultats);
  (<HTMLInputElement>document.getElementById("code")).value="";
}

getRandomInt(n: number): number{
  return Math.floor(Math.random()*n)
}

randomiseArray(a: number[]):number[] {
  let res:number[]=[];
  while(a.length>0){
    res.push(a.splice(this.getRandomInt(a.length),1)[0]);
  }
  console.log(res);
  return res;
}



}

interface TACHE {

id: string;

consigne: string;

code: string;

}

interface RESULTAT {

tache: string;

temps: number;

nbclick: number;

succes: boolean;

}
interface INSTRUCTION {

p1: string;

p2: string;

p3: string;

}
